<template>
    <div class="goodsmaterial spackage padding-20 bgc box-shadow" v-loading="loading">

        <!-- 顶部菜单栏 start -->
        <section class="gcm-header">
            <el-button type="primary" align="left" @click="createGM">新增素材</el-button>
            <div align="right" style="float:right">
                <el-select v-model="currentStatus" placeholder="商品状态">
                    <el-option
                        v-for="item in status"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-input placeholder="请输入商品名称" v-model="searchName" style="width: 240px"></el-input>
                <el-button type="primary" @click="search()" plain>搜索</el-button>
            </div>
        </section>
        <!-- 顶部菜单栏 end -->

        <section>
            <el-table :data="tableData">
                <el-table-column label="商品名称" align="left" width="260">
                    <template slot-scope="scope">
                        <div class="table-title">
                            <img :src="scope.row.logoatturlid" alt="headerimg">
                            <div class="table-txt">
                                <p class="sub-title" style="margin-bottom: 8px">{{scope.row.name}}</p>
                                <p style="height: 20px; font-size: 13px; color: #F56C6C">{{scope.row.saleprice}}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="catename" label="商品分类" align="center" width="180"></el-table-column>
                <el-table-column prop="eventcount" label="参与活动数" align="center"></el-table-column>
                <el-table-column prop="ordercount" label="累计购买数" align="center"></el-table-column>
                <el-table-column prop="ordermoney" label="累计购买金额" align="center"></el-table-column>
                <el-table-column prop="datetime" label="创建时间" align="center" width="200"></el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">
                        <div class="table-status">
                            <p class="status-1" v-if="scope.row.status == 10">正常</p>
                            <p class="status-4" v-if="scope.row.status == 11">暂停中</p>
                            <p class="status-5" v-if="scope.row.status == 100">已删除</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="right" width="180">
                    <template slot-scope="scope">
                        <div class="table-position">
                            <el-button v-if="scope.row.status !== 100" @click="editGCM(scope.row.innerid, 'edit')">编辑</el-button>
                            <span v-if="scope.row.status !== 100">|</span>
                            <el-button v-if="scope.row.status !== 100" @click="stopGCM(scope.row.innerid, scope.row.status)">{{scope.row.status === 11 ? '恢复' : '暂停'}}</el-button>
                            <span v-if="scope.row.status !== 100">|</span>
                            <el-button v-if="scope.row.status !== 100" @click="deleteGC(scope.row.innerid)">删除</el-button>
                            <el-button v-else @click="editGCM(scope.row.innerid, 'delete')">详情</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </section>
        <!-- end 表单 -->

        <!-- 删除 -- 弹窗 -- start -->
        <el-dialog title="提示" :visible.sync="deleteDialog" width="25%" class="dele_dialog">
            <span class="dele_tips">确定删除该素材？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialog = false">取 消</el-button>
                <el-button type="primary" @click="deleteSureEvent('100')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 删除 -- 弹窗 -- end -->

        <!-- 暂停 分类 -- 弹窗 -- start -->
        <el-dialog title="提示" :visible.sync="stopDialog" width="25%" class="dele_dialog">
            <span class="dele_tips">确定要{{isStop ? '恢复' : '暂停'}}该素材吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="stopDialog = false">取 消</el-button>
                <el-button type="primary" @click="deleteSureEvent(isStop ? '10' : '11')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 暂停 分类 -- 弹窗 -- end -->

        <section>
            <el-pagination background layout="prev,pager,next" :total="rowCount"  @current-change="fPage()" :current-page.sync="currentPage" align="center" style="margin-top:20px"></el-pagination>
        </section>
        <!-- end 分页 -->

    </div>
</template>

<script>
import {getMaterialsList, deleteStarsockpuppet} from '@/api/cPurchaseApi'
import {getCookie} from '@/common/js/tools'
import {mapActions} from 'vuex'
import $ from 'jquery'

export default {
    name: 'goodsMaterial',
    data() {
        return {
            loading: false,
            token: getCookie('token'),
            sessionUser: JSON.parse(sessionStorage['user']),
            shopID: JSON.parse(sessionStorage['shop']).ShopID,
            currentPage: 1,
            rowCount: 0,
            page: 1,
            tableData: [],
            status: [
                {
                    value: '',
                    label: '全部状态'
                },
                {
                    value: 10,
                    label: '正常'
                },
                {
                    value: 11,
                    label: '暂停中'
                },
                {
                    value: 100,
                    label: '已删除'
                }
            ],
            deleteDialog: false,
            searchName: '',
            currentStatus: '',
            stopDialog: false,
            isStop: false,
            currentid: ''
        }
    },
    mounted() {
        this.setLoading(true)
        this.getGMList(1, '', this.searchName ? this.searchName : '')
    },
    methods: {
        // 新增
        createGM() {
            this.$router.push({ name: 'createGM'})
        },

        // 编辑
        editGCM(id, type) {
            this.$router.push({ name: 'createGM', query: {'innerid': id, 'type': type}})
        },

        // 暂停
        stopGCM(id, status) {
            console.log(id, status)
            this.isStop = status === 10 ? false : true
            this.currentid = id
            this.stopDialog = true
        },

        // 删除
        deleteGC(id) {
            this.deleteDialog = true
            this.currentid = id
        },

        // 删除、暂停、恢复 调用接口
        deleteSureEvent(status) {
            let data = {
                innerid: this.currentid,
                status: status
            }
            this.setLoading(true)
            deleteStarsockpuppet({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.deleteDialog = false
                    this.stopDialog = false
                    this.$message.success('成功')
                    this.getGMList(1, this.currentStatus, this.searchName ? this.searchName : '')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 获取商品素材列表
        getGMList(page, status, name) {
            console.log(page, status, name)
            let data = {
                name: name,
                status: status,
                page: page,
                pageSize: 10
            }
            this.setLoading(true)
            getMaterialsList({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.rowCount = data.data.pageinfo.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        
        // 商品分类搜索
        search() {
            console.log(this.currentStatus)
            this.setLoading(true)
            this.getGMList(1, this.currentStatus, this.searchName)
        },

        // 分页
        fPage() {
            this.setLoading(true)
            let clickPage = $('.el-pagination .active').html()
            this.getGMList(clickPage, this.currentStatus, this.searchName ? this.searchName : '')
        },

        ...mapActions([
            'setLoading'
        ])
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/starmgt";
    .goodsmaterial {
        .el-table {
            .sub-title {
                display: -webkit-box;
                max-height: 40px;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                -moz-box-orient: vertical;
                -ms-box-orient: vertical;
                box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }

        }
        .gcm-header {
            height: 40px;
            margin-bottom: 20px;
            .el-input__icon {
                height: 36px ;
            }
            .el-select,
            .el-select>.el-input,
            .el-button {
                height: 32px;
            }
            .el-select {
                width: 116px;
            }
            .el-select,
            .el-input {
                margin-right: 20px;
            }
        }
        .table-title {
            img {
                width: 60px;
                height: 60px;
            }

            .table-txt {
                display: block;
                width: calc(100% - 126px);
                height: 70px;
                p {
                    width: 100%;
                    height: 40px;
                }
            }

        }
        .table-position {
            .el-dropdown-link {
                a {
                    color: #303133;
                }
            }
        }
        .dele_dialog {
            border-radius: 4px;
            text-align: center;
            .dele_tips {
                color: #F56C6C;
            }
        }
        .table-status {
            .status-4 {
                color: #E6A23C
            }
            .status-5 {
                color: #606266
            }
        }
    }
</style>
